import { render, staticRenderFns } from "./tubi-company.vue?vue&type=template&id=39d07f6a"
import script from "./tubi-company.vue?vue&type=script&lang=ts"
export * from "./tubi-company.vue?vue&type=script&lang=ts"
import style0 from "./tubi-company.vue?vue&type=style&index=0&id=39d07f6a&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports